import React, { Component } from "react";
import { Switch, Route, HashRouter as Router } from 'react-router-dom';

import Home from "./Home";
import About from "./About";
import Navigation from "./Navigation";
import Circles from "./Circles";
import SidebarRoutes from "./SidebarRoutes";
import Pricing from "./Pricing";
import Contact from "./Contact";

import "./App.css";

export default class App extends Component {
  render() {
    return (
      <div className='app'>
        <Router>
          <Navigation />
          <Switch>
            <Route exact path='/' component={Home}></Route>
            <Route exact path='/about' component={About}></Route>
            <Route exact path='/walkthrough' component={Circles}></Route>
            <Route exact path='/pricing' component={Pricing}></Route>
            <Route exact path='/contactus' component={Contact}></Route>
          </Switch>
        </Router>
      </div>
    );
  }
}
